export function initStickyNav() {
    const menu = document.querySelector('.sticky-nav-menu');
    const mobileMenu = document.querySelectorAll('.sticky-nav-mobile-menu');
    // Get all anchor links with hash targets
    const navLinks = document.querySelectorAll('.sticky-nav-item a[href*="#"]');
    const sections = new Map();
    // Build a map of section IDs to elements
    navLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href) {
            const hashIndex = href.indexOf('#');
            if (hashIndex !== -1) {
                const hash = href.substring(hashIndex + 1);
                const section = document.getElementById(hash);
                if (section) {
                    sections.set(hash, section);
                }
            }
        }
    });
    // Scroll spy to update active state based on scroll position
    function updateActiveLink() {
        const headerElement = document.querySelector('.sticky-nav, header, nav');
        const headerHeight = headerElement ? headerElement.offsetHeight : 0;
        const scrollPosition = window.scrollY + headerHeight + 100; // Add offset for better UX
        let currentSection = '';
        // Find which section is currently in view
        sections.forEach((section, id) => {
            const sectionTop = section.getBoundingClientRect().top + window.scrollY;
            if (scrollPosition >= sectionTop) {
                currentSection = id;
            }
        });
        // Update active classes
        navLinks.forEach(link => {
            const href = link.getAttribute('href');
            if (href) {
                const hashIndex = href.indexOf('#');
                if (hashIndex !== -1) {
                    const hash = href.substring(hashIndex + 1);
                    const listItem = link.closest('.sticky-nav-item');
                    if (listItem) {
                        if (hash === currentSection) {
                            listItem.classList.add('active');
                        }
                        else {
                            listItem.classList.remove('active');
                        }
                    }
                }
            }
        });
    }
    // Update on scroll with throttling
    let scrollTimeout = null;
    window.addEventListener('scroll', () => {
        if (scrollTimeout) {
            window.cancelAnimationFrame(scrollTimeout);
        }
        scrollTimeout = window.requestAnimationFrame(() => {
            updateActiveLink();
        });
    });
    // Update on page load
    updateActiveLink();
    if (menu) {
        menu.addEventListener('click', function () {
            this.classList.toggle('active');
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', String(!isExpanded));
            mobileMenu.forEach(content => {
                content.classList.toggle('is-open');
            });
        });
    }
    const mobileMenuItems = document.querySelectorAll('.sticky-nav-mobile-menu .sticky-nav-item a');
    mobileMenuItems.forEach(item => {
        item.addEventListener('click', function () {
            if (menu) {
                menu.classList.remove('active');
                menu.setAttribute('aria-expanded', 'false');
            }
            mobileMenu.forEach(content => {
                content.classList.remove('is-open');
            });
        });
    });
    navLinks.forEach(link => {
        link.addEventListener('click', function () {
            navLinks.forEach(navLink => {
                const listItem = navLink.closest('.sticky-nav-item');
                if (listItem) {
                    listItem.classList.remove('active');
                }
            });
            const clickedItem = this.closest('.sticky-nav-item');
            if (clickedItem) {
                clickedItem.classList.add('active');
            }
        });
    });
    // Anchor link scroll handling with offset for sticky header
    // Use event delegation to catch all anchor link clicks (including dynamically added ones)
    document.addEventListener('click', function (e) {
        const target = e.target;
        const link = target.closest('a[href*="#"]');
        if (!link)
            return;
        const href = link.getAttribute('href');
        if (!href)
            return;
        // Extract the hash part (handles both "#section" and "page.html#section")
        const hashIndex = href.indexOf('#');
        if (hashIndex === -1 || href === '#') {
            return;
        }
        const hash = href.substring(hashIndex + 1);
        const urlBeforeHash = hashIndex > 0 ? href.substring(0, hashIndex) : '';
        // Check if it's a same-page anchor
        const currentURL = window.location.href.split('#')[0];
        const linkURL = urlBeforeHash || currentURL;
        const isSamePage = linkURL === currentURL || urlBeforeHash === '';
        // Only handle same-page anchors
        if (!isSamePage) {
            return;
        }
        const targetElement = document.getElementById(hash);
        if (targetElement) {
            e.preventDefault();
            // Close mobile menu first if open
            const menu = document.querySelector('.sticky-nav-menu');
            const mobileMenus = document.querySelectorAll('.sticky-nav-mobile-menu');
            const isMobile = window.innerWidth < 992;
            if (menu) {
                menu.classList.remove('active');
                menu.setAttribute('aria-expanded', 'false');
            }
            mobileMenus.forEach(content => {
                content.classList.remove('is-open');
            });
            // Scroll to target with offset for sticky header
            const scrollToTarget = () => {
                const headerElement = document.querySelector('.sticky-nav, header, nav');
                const headerHeight = headerElement ? headerElement.offsetHeight : 0;
                const additionalOffset = isMobile ? 30 : 15;
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - additionalOffset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            };
            // If mobile menu is open, wait for it to close before scrolling
            if (isMobile && mobileMenus.length > 0 && mobileMenus[0].classList.contains('is-open')) {
                requestAnimationFrame(() => {
                    requestAnimationFrame(scrollToTarget);
                });
            }
            else {
                scrollToTarget();
            }
        }
    });
}
